import { render, staticRenderFns } from "./clear-all-trash.html?vue&type=template&id=222b7050&scoped=true&external"
import script from "./clear-all-trash.js?vue&type=script&lang=js&external"
export * from "./clear-all-trash.js?vue&type=script&lang=js&external"
import style0 from "./clear-all-trash.scss?vue&type=style&index=0&id=222b7050&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b7050",
  null
  
)

export default component.exports